import TextField from 'material-ui/TextField/TextField';

export default TextField;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/TextField/index.ts